import React, { useContext, useEffect } from 'react';

import { Route, Switch } from 'react-router-dom';

import Application from '@xingternal/malt-application';
import { render, config, Miss, withServerData } from '@xingternal/hops';
import { Grid, Row, Column } from '@xingternal/malt-grid';

import { XingFrameProvider } from '@xingternal/xing-frame-provider';
import withStaticData from '@xingternal/xing-frame-provider/withStaticData';
import navigationData from '@xingternal/xing-frame-provider/data/navigation';
import LoggedoutView from '@xingternal/xing-view/LoggedoutView';

import GdprImage from './Components/Illustrations/GdprImage';
import HtmlHead from './Components/HtmlHead/HtmlHead';
import Spacer from './Components/Spacer/Spacer';
import ScrollToTop from './Components/ScrollToTop/ScrollToTop';

import routes from './routes';
import styles from './app.css';
import Store, { StoreProvider } from './store';

const StaticFrame = withStaticData({ navigationData })(XingFrameProvider);

const App = withServerData(({ serverData }) => {
  const { dispatch } = useContext(Store);

  // Only execute on first render (like ComponentDidMount)
  useEffect(() => {
    dispatch({ type: 'HYDRATE_WITH_SERVER_DATA', payload: serverData });
  }, []);

  return (
    <>
      <HtmlHead />
      <ScrollToTop />
      <StaticFrame>
        <LoggedoutView
          homeLink={config.externalUrl}
          className={styles.app}
          hasSidebar={false}
          type={'wide'}
          whiteHeader
          hideButtons
          isStatic
        >
          <Application loggedOut>
            <Grid type={'wide'} outermost>
              <Row outermost>
                <Column
                  size={12}
                  offset={0}
                  sizeTablet={8}
                  offsetTablet={2}
                  sizeDesktop={4}
                  offsetDesktop={4}
                >
                  <Switch>
                    {routes
                      .filter(({ disabled }) => !disabled)
                      .map(({ path, component }) => (
                        <Route
                          exact
                          path={path}
                          key={path}
                          component={component}
                        />
                      ))}
                    <Miss />
                  </Switch>
                  <GdprImage />
                  <Spacer size={32} media={'tablet'} />
                </Column>
              </Row>
            </Grid>
          </Application>
        </LoggedoutView>
      </StaticFrame>
    </>
  );
});

const reducers = {
  root: (state = {}, _action) => state,
};

export default render(
  <StoreProvider>
    <App />
  </StoreProvider>,
  { redux: { reducers } }
);
